import { useQuery } from '@tanstack/react-query';
import { supabase } from '../lib/supabase';
import { Sale, SearchFilters } from '../types';

interface UseSalesOptions {
  city?: string;
  filters?: Partial<SearchFilters>;
  enabled?: boolean;
}

export const useSales = ({ city, filters, enabled = true }: UseSalesOptions = {}) => {
  return useQuery({
    queryKey: ['sales', city, filters],
    queryFn: async (): Promise<Sale[]> => {
      let query = supabase
        .from('sales')
        .select('*, sale_photos(photo_url, display_order)')
        .eq('is_archived', false);

      if (city) {
        query = query.eq('city', city);
      }

      if (filters?.query) {
        query = query.or(`title.ilike.%${filters.query}%,description.ilike.%${filters.query}%`);
      }

      // Apply sorting
      switch (filters?.sortBy) {
        case 'date':
          query = query.order('start_date', { ascending: true });
          break;
        case 'relevance':
        default:
          query = query.order('start_date', { ascending: true });
          break;
      }

      const { data, error } = await query;

      if (error) {
        console.error('Error fetching sales:', error);
        throw error;
      }

      return data || [];
    },
    enabled,
    staleTime: 1000 * 30, // 30 seconds - reduces React Query cache
  });
};

export const useSalesByCity = (city: string) => {
  return useSales({ city });
};
